export enum ButtonSize {
    small = 'small',
    medium = 'medium',
    large = 'large',
}
